// export const baseUrl = "http://localhost:6464";
export const baseUrl = "https://atc.l-tt.accenture.com/l-tt-apis";

export const allowedPeople = [
    "h.srinivasan", "s.a.thiruveedhula", "mamta.thakur", "ankita.rawat.garg", "aluru.akash", "varsha.a.tyagi", "shriya.jaswani"
];